const pad = (value) => String(value).padStart(2, '0');

// UTC ISO 문자열이나 Date를 현재 브라우저의 datetime-local 입력 형식으로 변환한다.
export const toLocalDateTimeInput = (value = new Date()) => {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return `${value}T00:00`;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
        + `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// datetime-local 값을 시간대가 명확한 UTC ISO 문자열로 변환해 서버 환경 의존성을 제거한다.
export const toUtcDateTime = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toISOString();
};
